import { render, staticRenderFns } from "./research.vue?vue&type=template&id=4f5cd42b&scoped=true&"
import script from "./research.vue?vue&type=script&lang=js&"
export * from "./research.vue?vue&type=script&lang=js&"
import style0 from "./research.vue?vue&type=style&index=0&id=4f5cd42b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cd42b",
  null
  
)

export default component.exports